<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-heading">Категории</div>

      <div class="panel-body">

        <div class="loader" v-show="!loaded" style="
          position: absolute;
          inset: 0px 15px;
          background-color: aliceblue;
          z-index: 10;
          opacity: 0.8;"></div>

        <div class="loader" v-show="!loaded"></div>

        <div class="row">
          <div class="col-md-8">

          </div>
          <div class="col-md-4">
            <button class="btn btn-default pull-right" type="submit" @click="add()">
              Добавить
            </button>
          </div>
        </div>

        <table class="table">
          <thead>
          <tr>
            <th>#</th>
            <th>Название</th>
            <th>Это еда</th>
            <th>Это напиток</th>
            <th>Это пирог</th>
            <th>Нет в наличии</th>
            <th>Сортировка</th>
            <th class="text-right">Действие</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in list" :class="{'hidden-element': !item.visible}">
            <td>{{item.id}}</td>
            <td>{{item.name}}</td>
            <td>{{item.is_food ? 'Да' : 'Нет'}}</td>
            <td>{{item.is_drinks ? 'Да' : 'Нет'}}</td>
            <td>{{item.is_main ? 'Да' : 'Нет'}}</td>
            <td>{{item.not_available ? 'Да' : 'Нет'}}</td>
            <td>{{item.sort}}</td>
            <td>
              <button type="button" class="btn btn-default btn-sm pull-right" @click="edit(item)"><span class="glyphicon glyphicon-edit"></span></button>
              <button type="button" class="btn btn-default btn-sm pull-right" @click="del(item.id, item.name)"><span class="glyphicon glyphicon-trash"></span></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <modal v-model="modalShow" title="Категория" @hide="modalHide()" @before-close="beforeClose">
      <!--error-->
      <div class="alert alert-danger fade in" v-show="modalError">
        <p>{{modalError}}</p>
      </div>

      <!--form-->
      <form name="modal-form" id="modal-form">
        <div class="form-group">
          <label for="name" class="control-label">Название:</label>
          <input class="form-control" id="name" v-model="modalData.name">
        </div>
        <div class="form-group">
          <label for="slug" class="control-label">URL (только латинские буквы и "-"):</label>
          <input class="form-control" id="slug" v-model="modalData.slug">
        </div>
        <div class="form-group">
          <label for="description" class="control-label">Описание:</label>
          <textarea class="form-control" id="description" v-model="modalData.description" rows="15"></textarea>
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" v-model="modalData.is_food">
            Это еда
          </label>
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" v-model="modalData.is_drinks">
            Это напиток
          </label>
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" v-model="modalData.is_main">
            Это пирог
          </label>
        </div>
        <div class="checkbox" style="margin-top:35px;">
          <label>
            <input type="checkbox" v-model="modalData.visible">
            Включить показ на сайте
          </label>
        </div>
        <div class="checkbox" style="margin-top:35px;">
          <label>
            <input type="checkbox" v-model="modalData.not_available">Нет в наличии</label>
        </div>
        <div class="form-group">
          <label for="sort" class="control-label">Сортировка:</label>
          <input class="form-control" id="sort" v-model="modalData.sort">
        </div>
        <div class="form-group">
          <label for="seo_title" class="control-label">SEO Title:</label>
          <input class="form-control" id="seo_title" v-model="modalData.seo_title" rows="15">
        </div>
        <div class="form-group">
          <label for="seo_description" class="control-label">SEO Description:</label>
          <textarea class="form-control" id="seo_description" v-model="modalData.seo_description" rows="10"></textarea>
        </div>

      </form>

      <div slot="footer">
        <btn type="primary" class="pull-left" @click="store()">Сохранить</btn>
        <btn type="default" class="pull-left" @click="close()">Отмена</btn>
      </div>
    </modal>
  </div>
</template>

<script>
  import {api} from './http'
  var config = require('./config')

  export default {
    mounted () {
    },
    data () {
      return {
        modalShow: false,
        modalData: {},
        modalError: '',
        loaded: false,
        list: [],
        url: config.appUrl
      }
    },
    beforeCreate () {
      this.loaded = false
      api.post('categories/list').then(response => {
        this.loaded = true
        this.list = response.data.items
      })
    },
    methods: {
      beforeClose () {
      },
      refreshList () {
        this.loaded = false
        api.post('categories/list').then(response => {
          this.loaded = true
          this.list = response.data.items
        })
      },
      add () {
        this.modalShow = true
      },
      edit (item) {
        var copyItem = {}
        Object.assign(copyItem, item)
        this.modalShow = true
        this.modalData = copyItem
      },
      close () {
        this.resetForm()
        this.modalShow = false
        this.modalError = ''
        this.resetModal()
      },
      modalClose () {
        this.resetForm()
        this.modalShow = false
        this.modalError = ''
        this.resetModal()
      },
      modalHide () {
        this.modalClose()
      },
      resetForm () {
        var form = document.querySelector('#modal-form')
        form.reset()
      },
      store () {
        var formData = new FormData()
        for (let key in this.modalData) {
          if (Array.isArray(this.modalData[key])) {
            for (let i in this.modalData[key]) {
              formData.append(key + '[]', this.modalData[key][i])
            }
          } else {
            let val = this.modalData[key] || ''
            formData.append(key, val)
          }
        }

        api.post('categories/store', formData).then(response => {
          if (response.data.success) {
            this.modalClose()
            this.refreshList()
          } else {
            this.modalError = response.data.message
          }
        })
      },
      del (id, name) {
        if (!confirm('Удалить категорию "' + name + '"')) {
          return
        }

        var formData = new FormData()
        formData.append('id', id)

        api.post('categories/delete', formData)
          .then(res => { this.refreshList() })
      },
      resetModal () {
        this.modalData = {}
      }
    }
  }
</script>

<style>
  .image-wrap {
    width: 370px;
    height: 248px;
    background-size: cover;
    border: 1px solid silver;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .hidden-element {
    background-color: #c0c0c05c;
    color: silver;
  }
</style>



// WEBPACK FOOTER //
// src/components/AdminCategories.vue